import '../App.css';
import React, { useState, useEffect } from 'react';
import { RiArrowDropRightLine } from 'react-icons/ri';
import { useApolloClient } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { PAGES } from '../constants/Pages';
import { MESSAGE } from '../constants/Message';
import Header from './Header';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { getMessage } from '../translations';

function ContractScreen() {
  const [showContractPopup, setShowContractPopup] = useState(false);
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  const [validityMonth, setValidityMonth] = useState('');
  const [marketType, setMarketType] = useState('');
  const [otherRef, setOtherRef] = useState('');
  const navigate = useNavigate();
  const handleGoButtonClick = (e) => {
    e.preventDefault();
    if (!validityMonth || !marketType) {
      setShowValidationMessage(true);
    } else {
      navigate(`/${PAGES.CONTRACTAPP}/${otherRef}&${validityMonth}&${marketType}`);
    }
  };

  return (
    <>
      <body>
        <Header />
        <section id='deliveries-section' className='active'>
          <div id='container12' className='container columns full screen'>
            <div className='wrapper'>
              <div
                className='main-inner'
                data-onvisible-trigger='1'
                data-reorder='1,0'
                data-reorder-breakpoint='medium'
                style={{ opacity: 1 }}
              >
                <div className='w-50'>
                  <div className='container12info'>
                    <h2 id='text29' className='style8'>
                      <span className='p'>{getMessage('CONTRACT_IMPORT')}</span>
                    </h2>
                    <ul
                      id='buttons24'
                      className='style1 buttons'
                      style={{ opacity: 1 }}
                    >
                      <li>
                        <button
                          className='QuantityAddBtn button n01'
                          onClick={() => {
                            setShowContractPopup(true);
                          }}
                        >
                          <RiArrowDropRightLine className='startIcon' />{' '}
                          {getMessage('CONTRACT')}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='w-40'>
                  <div id='image06' className='image full'>
                    <span className='frame deferred'>
                      <img
                        src='https://julesai.com/assets/images/image06.png'
                        data-src='done'
                        alt=''
                        style={{ opacity: 1 }}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </body>
      {showContractPopup ? (
        <div className='overlay-box'>
          <div className='popup'>
            <a
              className='close'
              onClick={() => {
                setShowContractPopup(false);
              }}
            >
              <svg
                className='sc-gsnTZi GjRDn MuiSvgIcon-root MuiSvgIcon-fontSizeMedium'
                focusable='false'
                viewBox='0 0 24 24'
                aria-hidden='true'
                data-testid='CloseIcon'
              >
                <path
                  d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 
                6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
                ></path>
              </svg>
            </a>
            <div className='content'>
              <form id='simpleForm'>
                <div className='AddCategoryBody'>
                  <h4>{getMessage('CONTRACT_IMPORT')}</h4>
                  <FormControl
                    className='FormField'
                    sx={{ m: 1, minWidth: '47%' }}
                  >
                    <Select
                      value={validityMonth}
                      onChange={(e) => setValidityMonth(e.target.value)}
                      required
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      <MenuItem value={''}>
                        {getMessage('Select validity month')}
                      </MenuItem>
                      <MenuItem value={'1'}>January</MenuItem>
                      <MenuItem value={'2'}>February</MenuItem>
                      <MenuItem value={'3'}>March</MenuItem>
                      <MenuItem value={'4'}>April</MenuItem>
                      <MenuItem value={'5'}>May</MenuItem>
                      <MenuItem value={'6'}>June</MenuItem>
                      <MenuItem value={'7'}>July</MenuItem>
                      <MenuItem value={'8'}>August</MenuItem>
                      <MenuItem value={'9'}>September</MenuItem>
                      <MenuItem value={'10'}>October</MenuItem>
                      <MenuItem value={'11'}>November</MenuItem>
                      <MenuItem value={'12'}>December</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    className='FormField'
                    sx={{ m: 1, minWidth: '47%' }}
                  >
                    <Select
                      value={marketType}
                      onChange={(e) => setMarketType(e.target.value)}
                      required
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      <MenuItem value={''}>
                        {getMessage('Select market type')}
                      </MenuItem>
                      <MenuItem value={'EXPORT'}>Export</MenuItem>
                      <MenuItem value={'LOCAL'}>Local</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    className='FormField'
                    sx={{ m: 1, minWidth: '47%' }}
                  >
                    <TextField
                      id="outlined-basic" 
                      variant="outlined" 
                      placeholder='Other ref' 
                      onChange={(e) => setOtherRef(e.target.value)} />
                  </FormControl>
                  <div className='validationMsg'>
                    {showValidationMessage && (!validityMonth || !marketType) && (
                      <p className='errorMsg'>
                        {getMessage('POPUP_LOADING_VALIDATION')}
                      </p>
                    )}
                  </div>
                  <div className='btnSection'>
                    <Button variant='contained' onClick={handleGoButtonClick}>
                      {getMessage('GO')}
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default ContractScreen;